import React from "react";
const faqData = [
  {
    id: 1,
    question: "Why join NAMESPACE BPIT?",
    answer: "NAMESPACE BPIT is a dynamic technical society that focuses on skill development, peer collaboration, and fostering a vibrant tech culture. By joining, you gain access to exclusive internal programs, mentorship, and personal guidance, along with a platform to develop your technical and interpersonal skills."
  },
  {
    id: 2,
    question: "Who can join NAMESPACE BPIT?",
    answer: "Any first or second-year student enrolled in the B.Tech program at BPIT who is passionate about technology and eager to learn, grow, and collaborate with peers should consider joining. Whether you’re just starting out or are already honing your skills, NAMESPACE BPIT provides a platform to support your growth."
  },
  {
    id: 3,
    question: "Is there a membership fee?",
    answer: "No, NAMESPACE BPIT does not charge any membership fee. Our society is committed to being an accessible platform for all tech enthusiasts."
  },
  {
    id: 4,
    question: "How often do interviews for NAMESPACE BPIT membership take place?",
    answer: "Membership interviews are conducted biannually and are open to first and second-year B.Tech students. Stay tuned for announcements to secure your opportunity to join the society."
  },
  {
    id: 5,
    question: "What activities does NAMESPACE BPIT organize?",
    answer: "We organize a range of activities, including public workshops, tech contests, seminars, and hackathons, as well as several internal programs for members to foster their growth and build a diverse developer community within the society."
  },
  {
    id: 6,
    question: "What if I cannot become a member of the society?",
    answer: "Non-members can still participate in public workshops and tech events organized by NAMESPACE BPIT to stay connected with the tech culture at BPIT."
  }
];

  export default faqData;